import React from "react";
import { useSelector } from "react-redux";
import CibilCredential from "./cibilCredential";
import NewCibilCredential from "./NewCibilCredential";
const RoleBasedCibilCredential = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);

  if (!userInfo) return <div>Loading...</div>;

  const roleId = Number(userInfo.role);
  console.log("Aaj",roleId)
  if(roleId==1)
  {
    return <CibilCredential/>
  }
  else
  {
    return <NewCibilCredential/>
  }
};

export default RoleBasedCibilCredential;
